var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('statement',{staticClass:"pt-2",attrs:{"color":"transparent","query":_vm.query,"data-variables":_vm.dataVariables,"disable-edit":true}})}
var staticRenderFns = []

export { render, staticRenderFns }